import { Header } from '../components/structures';
import { expertiseBg } from '../images/expertise';
import { BlockCard, Divider, SafetyText } from '../components/structures/safety';
import { book, eBook, heroSection, joinUs, safetyDoctrine, safetyFirstBackground, trustGraphic } from '../images/safety';
import JoinUsImageBg from '../components/structures/safety/JoinUsImageBg';
import CardWithIcon from '../components/structures/safety/CardWithIcon';
import {
  CommitmentIcon,
  HealthIcon,
  IncidentIcon,
  ResponsibilityBoldIcon,
  ResponsibilityIcon,
  SafetyBoldIcon,
  SafetyIcon,
  TrainingBoldIcon,
  TrainingIcon,
  UnderstandingBoldIcon,
  UnderstandingIcon,
} from '../svgs/safety';
import TrustProgram from '../components/structures/safety/TrustProgram';
import { Box } from '@material-ui/core';

const cardList = [
  {
    title: 'Health and Safety Leadership Training (HSLT)',
    description:
      'HSLT focuses on developing leadership skills with an emphasis on safety. This program trains supervisors and managers to identify potential hazards, conduct effective safety meetings, and foster a safety culture throughout the organization.',
    svg: <HealthIcon />,
  },
  {
    title: 'Incident Prevention Program (IPP)',
    description:
      'The IPP is designed to prevent incidents before they occur. By leveraging predictive analytics and thorough site assessments, we identify potential risks and implement preventative measures to mitigate them.',
    svg: <IncidentIcon />,
  },
  {
    title: 'Commitment to Continuous Improvement',
    description:
      'Our dedication to safety is unwavering, but we recognize that there is always room for improvement. To ensure we are at the forefront of safety innovation, we continuously seek employee feedback, conduct regular safety audits, and stay abreast of the latest industry best practices.',
    svg: <CommitmentIcon />,
  },
];

const programList = [
  {
    description: 'Providing comprehensive safety training to prepare employees for any situation.',
    title: 'Training',
    svgIcon: <TrainingIcon />,
    svgIconOnHover: <TrainingBoldIcon />,
  },
  {
    description: 'Fostering a culture of accountability for personal and team safety.',
    title: 'Responsibility',
    svgIcon: <ResponsibilityIcon />,
    svgIconOnHover: <ResponsibilityBoldIcon />,
  },
  {
    description: 'Ensuring thorough knowledge of safety protocols to minimize incidents.',
    title: 'Understanding',
    svgIcon: <UnderstandingIcon />,
    svgIconOnHover: <UnderstandingBoldIcon />,
  },
  {
    description: 'Focusing on proactive measures to maintain safety at all times.',
    title: 'Safety',
    svgIcon: <SafetyIcon />,
    svgIconOnHover: <SafetyBoldIcon />,
  },
  {
    description: 'Collaborating effectively to create and maintain a safe working environment.',
    title: 'Teamwork',
    svgIcon: <TrainingIcon />,
    svgIconOnHover: <TrainingBoldIcon />,
  },
];

const Safety = () => {
  return (
    <>
      <Header
        title="Safety in Every Action"
        description="At Utilities One, safety is more than just a commitment; it's a fundamental part of our culture. We believe every employee, contractor, and community member deserves a safe environment, and we strive to ensure that our operations reflect this belief daily."
        image={heroSection}
      />
      <BlockCard
        title={'Our Safety Doctrine'}
        text={
          'At Utilities One, safety is not just a priority but a core value that shapes everything we do. Our Safety Approach is built on five essential elements guiding our efforts to ensure the well-being of our employees, partners, and communities.'
        }
        image={safetyDoctrine}
        width={690}
        height={690}
        hasDivider
        id={'our-safety-doctrine'}
      />

      <Divider />

      <BlockCard
        text={
          'Together, these elements form the backbone of our Safety Approach, ensuring that we maintain the highest safety standards in all our operations.'
        }
        image={trustGraphic}
        isLeftSideImage
        width={790}
        height={790}
        hasDivider
      />
      <Divider />
      <Box id={'trust-program'} />
      <TrustProgram titleOrange={'TRUST'} titleBlack={'Program'} programList={programList} />
      <Divider />
      <CardWithIcon cardList={cardList} />
      <JoinUsImageBg
        title={'Join Us in Our Commitment to Safety'}
        description={
          "Safety is a shared responsibility. Whether you're an employee, contractor, or community member, we invite you to join us in our commitment to creating the safest possible environment for everyone involved in our operations."
        }
        image={joinUs}
      />
      <BlockCard
        title={'Download Our Safety eBook'}
        text={'Download our comprehensive safety eBook for an in-depth look at our safety programs and best practices.'}
        image={eBook}
        width={640}
        height={481}
        hasButton
        id={'safety-ebook'}
      />
      <SafetyText image={safetyFirstBackground} title={'Safety First,\n' + 'Safety Always'} />
    </>
  );
};

export default Safety;
